class AppointmentSchedulingController {
  /* @ngInject */
  constructor($log, $rootScope, $scope, toastr, Business, ngDialog) {
    Object.assign(this, {
      $rootScope,
      $log,
      Business,
      ngDialog,
      toastr,
      active: 'hours',
      hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      minutes: {
        10: ['00', '10', '20', '30', '40', '50'],
        15: ['00', '15', '30', '45']
      },
      selectedMinutes: [],
      callDurationOptions: [5, 10, 15, 20, 25, 30],
      numClinicianOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      meridiems: ['AM', 'PM'],
      timezones: ['Pacific', 'Central', 'Eastern'],
      schedule: {},
      async_and_phoneSchedules: [],
      // callBookings
      slvSchedules: [],
      callBookingToEdit: {},
      editing: false,
      modality: ''
    });
    /*
        var today = moment().format('YYYY-MM-DD');
    
        var offsetLos_Angeles = moment.tz(today, 'America/Los_Angeles').format('Z');  // "-08:00" => -480 minutes
        console.log('offsetLos_Angeles');
        console.log(offsetLos_Angeles);
    
        var offsetPhoenix = moment.tz(today, 'America/Phoenix').format('Z');  // "-07:00" => -420 minutes
        console.log('offsetPhoenix');
        console.log(offsetPhoenix);
    
        this.offsetMinutesPhoenixLos_Angeles = this.convertStringToMinutes(offsetPhoenix) - this.convertStringToMinutes(offsetLos_Angeles);
        console.log('this.offsetMinutesPhoenixLos_Angeles');
        console.log(this.offsetMinutesPhoenixLos_Angeles);
    */

    /****************** DO NOT DELETE THIS SECTION / IT WILL BE HELPFUL *********************/

    /*
    // Los_Angeles observes DST
    // var offset1 = moment.tz("2018-11-01", 'America/Los_Angeles').format('Z z');  // -07:00 PDT
    // var offset2 = moment.tz("2018-11-21", 'America/Los_Angeles').format('Z z');  // -08:00 PST
     console.log("OFFSET-Los_Angeles");
     console.log("2018-11-01");
    var offset1 = moment.tz("2018-11-01", 'America/Los_Angeles').format('Z');  // -07:00
    console.log(offset1);
     console.log("2018-11-21");
    var offset2 = moment.tz("2018-11-21", 'America/Los_Angeles').format('Z');  // -08:00
    console.log(offset2);
     // Phoenix does not observe DST
    // var offset3 = moment.tz("2018-11-01", 'America/Phoenix').format('Z z');  // -07:00 MST
    // var offset4 = moment.tz("2018-11-21", 'America/Phoenix').format('Z z');  // -07:00 MST
     console.log("OFFSET-Phoenix");
     console.log("2018-11-01");
    var offset3 = moment.tz("2018-11-01", 'America/Phoenix').format('Z'); // -07:00
    console.log(offset3);
     console.log("2018-11-21");
    var offset4 = moment.tz("2018-11-21", 'America/Phoenix').format('Z'); // -07:00
    console.log(offset4);
     console.log("convertStringToMinutes('07:45')" + convertStringToMinutes('07:45'));
    console.log("convertStringToMinutes('-07:45')" + convertStringToMinutes('-07:45'));
    console.log("convertStringToMinutes('27:45')" + convertStringToMinutes('27:45'));
    console.log("convertStringToMinutes('-27:45')" + convertStringToMinutes('-27:45'));
    console.log("convertMinutesToTimeString(465)" + convertMinutesToTimeString(465));
    console.log("convertMinutesToTimeString(-465)" + convertMinutesToTimeString(-465));
    console.log("convertMinutesToTimeString(1665)" + convertMinutesToTimeString(1665));
    console.log("convertMinutesToTimeString(-1665)" + convertMinutesToTimeString(-1665));
    */

    this.getAsyncAndPhoneSchedules();
    this.getSlvSchdules();
  } // REFERENCE:
  // https://simple.wikipedia.org/wiki/12-hour_clock
  // TO CONVERT BETWEEN 12H AND 24H TIME FORMATS
  // EXAMPLES:
  // "00:30:00" => "12:30AM"
  // "17:00:00" => "5:00PM"


  convertTime24to12 = time24h => {
    let [hours, minutes, seconds] = time24h.split(':');
    let hours_24_as_integer = parseInt(hours, 10);
    let modifier = '';

    if (hours === '00' || hours === '24') {
      modifier = 'AM';
      hours = '12';
    } else if (hours_24_as_integer < 12) {
      modifier = 'AM';
      hours = '' + hours_24_as_integer;
    } else if (hours_24_as_integer >= 12) {
      modifier = 'PM';
      if (hours_24_as_integer > 12) hours_24_as_integer = hours_24_as_integer - 12;
      hours = '' + hours_24_as_integer;
    }

    return hours + ':' + minutes + modifier;
  }; // EXAMPLES:
  // "12:30 AM" => "00:30:00"
  // "5:00 PM" => "17:00:00"

  convertTime12to24 = (time12h, type) => {
    let [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours.length === 1) hours = '0' + hours;

    if (hours === '12' && minutes === '00' && modifier === 'AM') {
      if (type === 'close') {
        hours = '24';
      } else {
        hours = '00';
      }
    } else if (modifier === 'AM') {
      if (hours === '12') hours = '00';
    } else if (modifier === 'PM') {
      if (hours != '12') hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}:00`;
  };

  getAsyncAndPhoneSchedules() {
    this.Business.getSchedules('async_and_phone').then(({
      data
    }) => {
      this.async_and_phoneSchedules = data;
    }).catch(err => {
      this.toastr.error(`Error getting ASYNC + PHONE hours: ` + err.data.message.summary);
    });
  }

  getSlvSchdules() {
    this.Business.getSchedules('slv').then(({
      data
    }) => {
      this.slvSchedules = data;
    }).catch(err => {
      this.toastr.error(`Error getting SLV hours: ` + err.data.message.summary);
    });
  }

  editCallBooking(row, modality) {
    this.editing = true;
    this.selectedMinutes = this.minutes[row.call_duration_minutes];
    this.modality = modality;
    this.callBookingToEdit = this.setupCallBookingToEdit(row);
  }

  cancelSLV() {
    this.editing = false;
    this.callBookingToEdit = {};
  }

  confirm(day_name) {
    const config = {
      template: "app/components/modals/confirm.tpl.html",
      data: {
        title: "Confirm Call Booking Schedule",
        content: `Are you sure you want to change these hours for ${day_name}?`
      }
    };
    this.ngDialog.openConfirm(config).then(() => this.updateCallBooking(this.modality));
  }

  updateCallBooking(modality) {
    let payload = {};
    let errorMessage = "";

    if (!errorMessage) {
      let startTime = this.callBookingToEdit.start;
      let finishTime = this.callBookingToEdit.finish;
      let day_name = this.callBookingToEdit.day_name;
      let num_clinicians = this.callBookingToEdit.num_clinicians;
      let open_time = this.convertTime12to24(`${startTime.hour}:${startTime.minutes} ${startTime.meridiem}`, `open`);
      let close_time = this.convertTime12to24(`${finishTime.hour}:${finishTime.minutes} ${finishTime.meridiem}`, `close`);

      if (open_time === close_time) {
        errorMessage = "Start time and finish time can't be the same on " + day_name;
      }

      if (open_time > close_time) {
        errorMessage = "Start time can't be greater than finish time on " + day_name;
      }

      payload = {
        day_name,
        open_time,
        close_time,
        num_clinicians
      };
    }

    if (errorMessage) {
      this.toastr.warning(errorMessage);
      return;
    }

    this.Business.updateCallBooking(this.callBookingToEdit.id, payload, modality).then(() => {
      this.toastr.success(`${this.callBookingToEdit.day_name}'s schedule hours updated successfully`);
      this.editing = false;
      this.callBookingToEdit = {};

      if (modality === 'async_and_phone') {
        this.getAsyncAndPhoneSchedules();
      }

      this.getSlvSchdules();
    }).catch(err => {
      this.toastr.error(`Error updating ${this.callBookingToEdit.day_name}'s schedule hours: ` + err.data.message.summary);
    });
  }

  setupCallBookingToEdit(day) {
    let id, start, finish, day_name, callBookingToEdit, open_time, close_time, hour, minutes, num_clinicians;
    id = day.id;
    num_clinicians = day.num_clinicians;
    open_time = this.convertTime24to12(day.open_time);
    [hour, minutes] = open_time.split(":");
    start = {
      hour: hour,
      minutes: minutes.substring(0, 2),
      meridiem: minutes.substring(2)
    };
    close_time = this.convertTime24to12(day.close_time);
    [hour, minutes] = close_time.split(":");
    finish = {
      hour: hour,
      minutes: minutes.substring(0, 2),
      meridiem: minutes.substring(2)
    };
    day_name = day.day_name;
    callBookingToEdit = {
      id,
      start,
      finish,
      day_name,
      num_clinicians
    };
    return callBookingToEdit;
  }

}

AppointmentSchedulingController.$inject = ["$log", "$rootScope", "$scope", "toastr", "Business", "ngDialog"];
angular.module('pims').controller('AppointmentSchedulingController', AppointmentSchedulingController);